export default __webpack_public_path__ + "static/media/BV_image2.174b6f00.png";